import { WindowLocationWrapper } from "./WindowLocationWrapper";

export class DefaultWindowLocationWrapper implements WindowLocationWrapper {
	get pathname(): string {
		return window.location.pathname;
	}

	get search(): string {
		return window.location.search;
	}

	get hostname(): string {
		return window.location.hostname;
	}

	get pathWithQueryString(): string {
		return this.pathname + this.search;
	}
}
